/* 🤖 this file was generated by svg-to-ts */
export const matIconBatterySaver: {
  name: 'battery-saver';
  data: string;
} = {
  name: 'battery-saver',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 4h-2V2h-4v2H8c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h8c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-1 10h-2v2h-2v-2H9v-2h2v-2h2v2h2v2z"/></svg>`
};
